import type { PredefinedDateType } from '../types/models.js';

export const PREDEFINED_DATE_TYPES: Record<
  PredefinedDateType,
  {
    id: PredefinedDateType;
    label: string;
    description: string;
    icon: string;
    color: string;
  }
> = {
  deadline: {
    id: 'deadline',
    label: 'Deadline',
    description: 'Final date by which the work must be completed',
    icon: 'alert-circle',
    color: '#ef4444', // Red - urgent
  },
  due_date: {
    id: 'due_date',
    label: 'Due Date',
    description: 'Date when the work is expected to be delivered',
    icon: 'calendar-check',
    color: '#f59e0b', // Amber
  },
  next_update: {
    id: 'next_update',
    label: 'Next Update',
    description: 'Date of the next scheduled update',
    icon: 'refresh-cw',
    color: '#3b82f6', // Blue
  },
  expected_completion: {
    id: 'expected_completion',
    label: 'Expected Completion',
    description: 'Anticipated completion date',
    icon: 'target',
    color: '#10b981', // Green
  },
  estimated_completion: {
    id: 'estimated_completion',
    label: 'Estimated Completion',
    description: 'Estimated completion date',
    icon: 'clock',
    color: '#6366f1', // Indigo
  },
  review_date: {
    id: 'review_date',
    label: 'Review Date',
    description: 'Scheduled review date',
    icon: 'eye',
    color: '#8b5cf6', // Purple
  },
  feedback_due: {
    id: 'feedback_due',
    label: 'Feedback Due',
    description: 'Date by which feedback is expected',
    icon: 'message-square',
    color: '#ec4899', // Pink
  },
  go_live_date: {
    id: 'go_live_date',
    label: 'Go Live Date',
    description: 'Planned launch or go-live date',
    icon: 'rocket',
    color: '#14b8a6', // Teal
  },
  milestone_date: {
    id: 'milestone_date',
    label: 'Milestone Date',
    description: 'Key milestone date',
    icon: 'flag',
    color: '#f97316', // Orange
  },
  start_date: {
    id: 'start_date',
    label: 'Start Date',
    description: 'Date when work begins',
    icon: 'play',
    color: '#22c55e', // Green
  },
  presentation_date: {
    id: 'presentation_date',
    label: 'Presentation Date',
    description: 'Scheduled presentation or demo date',
    icon: 'presentation',
    color: '#0ea5e9', // Sky
  },
};

export const DATE_TYPE_LIST = Object.values(PREDEFINED_DATE_TYPES);
